// extracted by mini-css-extract-plugin
module.exports = {"links":"Socials_links__3Qh8y","link":"Socials_link__roq0R"};